<template>
  <Modal
    :title="$t('questionnaire.label.update')"
    name="UPDATE_QUESTIONNAIRE_MODAL"
    actions
  >
    <template v-slot:body>
      <h-loading v-if="loading" />

      <v-form ref="questionnaireForm" v-model="valid" v-if="questionnaire && questionnaire.id">
        <v-row>
          <v-col>
            <v-text-field
              v-model="questionnaire.name"
              :label="$t('questionnaire.label.create.name')"
              :rules="required"
              outlined
            />
          </v-col>
        </v-row>

        <AdminServiceTypeSelect
          v-model="questionnaire.current_services"
          :label="$t('questionnaire.label.create.serviceType')"
          :showOutterLabel="false"
          :dense="false"
        />

        <HCheckbox
          v-model="questionnaire.must_be_sent"
          :inputValue="questionnaire.must_be_sent"
          :rules="required"
          :label="$t('questionnaire.label.create.mustBeSent')"
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('UPDATE_QUESTIONNAIRE_MODAL')"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('appointment.closeModal.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="newQuestionnaire"
        :loading="isQuestionnaireLoading"
        :disabled="!valid"
        class="ml-5"
        color="primary"
        elevation="0"
      >
        {{ $t('create.save') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import HTextInput from '@/components/app/HTextInput'
import AdminServiceTypeSelect from '@/components/AdminServiceTypeSelect'
import HCheckbox from '@/components/app/HCheckbox'
import HAutocomplete from '@/components/app/HAutocomplete'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'QuestionnaireUpdate',
  components: {
    Modal,
    HTextInput,
    HAutocomplete,
    HCheckbox,
    AdminServiceTypeSelect
  },

  data() {
    return {
      valid: false,
      loading: false,
      type: [
        { name: this.$t('questionnaire.label.type.DEFAULT'), value: 'DEFAULT' },
        { name: this.$t('questionnaire.label.type.CUSTOM'), value: 'CUSTOM' }
      ],
      required: [(v) => (!!v && v.trim() != '') || this.$t('rules.required')],
    }
  },

  computed: {
    ...mapGetters(['isQuestionnaireLoading', 'questionnaire']),
  },

  methods: {
    ...mapActions([
      'closeModal',
      'openModal',
      'showErrorMessage',
      'updateQuestionnaire',
      'fetchQuestionnaires',
      'showSuccessMessage',
      'fetchQuestionnaire',
    ]),
    ...mapMutations(['setIsQuestionnaireLoading', 'setQuestionnaire']),

    async open(id) {
      this.loading = true
      this.openModal("UPDATE_QUESTIONNAIRE_MODAL")
      await this.fetchQuestionnaire(id).finally(() => this.loading = false)
    },

    async newQuestionnaire() {
      this.setIsQuestionnaireLoading(true)

      this.updateQuestionnaire(this.buildUpdateForm())
        .then(() => {
          this.resetForm()
          this.fetchQuestionnaires()
          this.closeModal('UPDATE_QUESTIONNAIRE_MODAL')
          this.showSuccessMessage(this.$t('questionnaire.label.successUpdate'))
        })
        .catch(({ data }) => {
          data?.errors && data?.errors?.length >= 1
            ? this.showErrorMessage(this.$t('questionnaire.label.create.' + data.errors[0].field) + ": " + data.errors[0].message)
            : this.showErrorMessage(data.message)
      })
      .finally(() => {
        this.setIsQuestionnaireLoading(false)
      })
    },

    buildUpdateForm() {
      return {
        id: this.questionnaire.id,
        name: this.questionnaire.name,
        must_be_sent: this.questionnaire.must_be_sent,
        service_types: this.questionnaire.current_services,
      }
    },

    resetForm() {
      this.setQuestionnaire({})
    },
  }
}
</script>
